$('.ctm_video_slider .multi-column').slick({
  dots: true,
  infinite: true,
  speed: 800,
  arrows:false,
  slidesToShow: 4,
  centerMode: true,
  centerPadding: '80px',
  slidesToScroll: 4,
  autoplay: true, // Enable autoplay by default (desktop)
  autoplaySpeed: 2000, // Optional: adjust autoplay interval
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
        autoplay: true // Disable autoplay on tablets
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true // Disable autoplay on small devices
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true // Disable autoplay on phones
      }
    }
  ]
});


$('.discount_container').slick({
  infinite: true,
  slidesToShow: 1,
  dots: false,
  speed: 500,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true, // Enable autoplay by default (desktop)
  autoplaySpeed: 2000,
  prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0665/4060/1563/files/Group_114.png?v=1749549998'>",
  nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0665/4060/1563/files/Group_113.png?v=1749549998'>"
});



if (window.matchMedia("(max-width:767px)").matches) {
  $('.mobile_slider_container').slick({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    slidesToScroll: 1,
    arrows: false
  });
  // $('.ctm_video_slider .multi-column').slick({
  //   infinite: true,
  //   slidesToShow: 1,
  //   dots: true,
  //   centerMode: true,
  //   centerPadding: '80px',
  //   slidesToScroll: 1,
  //   arrows: false
  // });



  $('.ctm_slider .product-list').slick({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    centerMode: true,
    centerPadding: '80px',
    slidesToScroll: 1,
    arrows: false
  });



  $('.prd_testimonial .multi-column').slick({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0665/4060/1563/files/Group_114.png?v=1749549998'>",
    nextArrow: "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0665/4060/1563/files/Group_113.png?v=1749549998'>"
  });



}
document.addEventListener('DOMContentLoaded', function () {
  const containers = document.querySelectorAll('.video-container');

  containers.forEach(container => {
    const video = container.querySelector('video');
    const icon = container.querySelector('.video_icon');

    function togglePlayback() {
      if (video.paused) {
        // Pause all other videos
        containers.forEach(otherContainer => {
          const otherVideo = otherContainer.querySelector('video');
          if (otherVideo !== video && !otherVideo.paused) {
            otherVideo.pause();
          }
        });
        video.play();
      } else {
        video.pause();
      }
    }

    // Hide icon when playing, show when paused
    video.addEventListener('play', () => {
      icon.style.display = 'none';
    });

    video.addEventListener('pause', () => {
      icon.style.display = 'block';
    });

    // Initial icon state
    icon.style.display = video.paused ? 'block' : 'none';

    // Add click listeners
    icon.addEventListener('click', togglePlayback);
    video.addEventListener('click', togglePlayback);
  });
});



// share button trigger 

document.addEventListener('click', function (e) {
  // Check if the clicked element has the class 'ctm_share'
  if (e.target.closest('.ctm_share')) {
    const targetButton = document.querySelector('.ctm_share_button .share-buttons');
    if (targetButton) {
      targetButton.click();
    } else {
      console.warn('Target share button not found');
    }
  }
});


// wishlist button trigger 

document.addEventListener('click', function (e) {
  const wishElement = e.target.closest('.product .ctm_wish');
  
  if (wishElement) {
    // Click the WishlistHero button
    const targetButton = document.querySelector('.wishlisthero-product-page-button-container button');
    if (targetButton) {
      targetButton.click();
    } else {
      console.warn('WishlistHero button not found');
    }

    // Toggle 'activewish' class on the clicked element
    wishElement.classList.toggle('activewish');
  }
});




// product image trigger with zoom 

document.querySelectorAll('.product-gallery__carousel img').forEach(function (img) {
  img.addEventListener('click', function () {
    const zoomButton = document.querySelector('open-lightbox-button button');
    if (zoomButton) {
      zoomButton.click(); // Trigger the button click
    }
  });
});



// product cart quick view button trigger 
document.querySelectorAll('.ctm_quick_view').forEach((item) => {
  item.addEventListener('click', function () {
    // Find the closest product card or container
    const productCard = this.closest('.product-card');

    if (productCard) {
      const quickAddButton = productCard.querySelector('.product-card__quick-add-button');
      if (quickAddButton) {
        quickAddButton.click(); // Trigger the click
      }
    }
  });
});





// document.querySelectorAll('.product-card .product-card__quick-add-button').forEach(function (button) {
//   button.addEventListener('click', function handler(event) {
//     event.preventDefault(); // Prevent default action

//     // Add 'active' class to .new_cart_section
//     const newCartSection = document.querySelector('.new_cart_section');
//     if (newCartSection) {
//       newCartSection.classList.add('active_bag');

//       // Remove 'active' after 3 seconds
//       setTimeout(function () {
//         newCartSection.classList.remove('active_bag');
//       }, 3000);
//     }

//     // Temporarily remove this event listener
//     button.removeEventListener('click', handler);

//     // Trigger the actual button click after 3 seconds
//     setTimeout(function () {
//       button.click(); // Now allow the default behavior

//       // Reattach the event listener
//       setTimeout(function () {
//         button.addEventListener('click', handler);
//       }, 100);
//     }, 3000);
//   });
// });



// function handleClick(button) {
//   function handler(event) {
//     event.preventDefault(); // Prevent default behavior

//     // Add 'active' class to .new_cart_section
//     const newCartSection = document.querySelector('.new_cart_section');
//     if (newCartSection) {
//       newCartSection.classList.add('active_bag');

//       // Remove 'active' after 3 seconds
//       setTimeout(function () {
//         newCartSection.classList.remove('active_bag');
//       }, 3000);
//     }

//     // Temporarily remove this event listener
//     button.removeEventListener('click', handler);

//     // Trigger the actual button click after 3 seconds
//     setTimeout(function () {
//       button.click(); // Trigger real action

//       // Reattach the event listener
//       setTimeout(function () {
//         button.addEventListener('click', handler);
//       }, 100);
//     }, 3000);
//   }

//   button.addEventListener('click', handler);
// }

// // Apply to both quick-add and buy-buttons
// document.querySelectorAll('.product-card__quick-add-button, .buy-buttons .button').forEach(handleClick);






// document.querySelectorAll('.product-card .product-card__quick-add-button').forEach(function (button) {
//   button.addEventListener('click', function handler(event) {
//     event.preventDefault(); // Stop immediate action

//     // Remove 'clicked' class from all cards
//     document.querySelectorAll('.product-card.clicked').forEach(function (card) {
//       card.classList.remove('clicked');
//     });

//     // Add 'clicked' class to the current card
//     const productCard = button.closest('.product-card');
//     if (productCard) {
//       productCard.classList.add('clicked');
//     }

//     // Remove the event listener temporarily
//     button.removeEventListener('click', handler);

//     // Trigger actual click after 3 seconds
//     setTimeout(function () {
//       button.click(); // This time, default behavior will run

//       // Remove class after 2 more seconds (5 sec total)
//       setTimeout(function () {
//         if (productCard) {
//           productCard.classList.remove('clicked');
//         }
//       }, 3000);

//       // Reattach the listener after the action
//       setTimeout(function () {
//         button.addEventListener('click', handler);
//       }, 100); // Short delay to avoid double firing
//     }, 3000);
//   });
// });


document.querySelectorAll('.header_wishlist').forEach(function (element) {
  element.addEventListener('click', function () {
    const wishlistAnchor = document.querySelector('.wishlisthero-floating-launcher-container a');
    if (wishlistAnchor) {
      wishlistAnchor.click();
    }
  });
});





document.addEventListener('DOMContentLoaded', function () {
  // On page load: restore 'activewish' class from localStorage
  const storedWishes = JSON.parse(localStorage.getItem('wishlistItems')) || [];

  storedWishes.forEach(id => {
    const el = document.querySelector(`.ctm_wish[data-id="${id}"]`);
    if (el) {
      el.classList.add('activewish');
    }
  });

  // Handle individual wishlist toggle
  document.addEventListener('click', function (e) {
    const wishElement = e.target.closest('.product .ctm_wish');

    if (wishElement) {
      const itemId = wishElement.dataset.id;
      if (!itemId) {
        console.warn('Missing data-id on .ctm_wish element');
        return;
      }

      let wishlist = JSON.parse(localStorage.getItem('wishlistItems')) || [];

      if (wishlist.includes(itemId)) {
        // Remove from localStorage and remove class
        wishlist = wishlist.filter(id => id !== itemId);
        localStorage.setItem('wishlistItems', JSON.stringify(wishlist));
        wishElement.classList.remove('activewish');
      } else {
        // Add to localStorage and add class
        wishlist.push(itemId);
        localStorage.setItem('wishlistItems', JSON.stringify(wishlist));
        wishElement.classList.add('activewish');
      }

      // Click the WishlistHero button
      const targetButton = document.querySelector('.wishlisthero-product-page-button-container button');
      if (targetButton) {
        targetButton.click();
      } else {
        console.warn('WishlistHero button not found');
      }
    }

    // Handle "Delete All" or "Delete" in WishlistHero
    if (
      e.target.closest('.wishlist-hero-list-card-footer-delete-all') ||
      e.target.closest('.wishlist-hero-list-card-footer-delete')
    ) {
      // Clear wishlistItems from localStorage
      localStorage.removeItem('wishlistItems');

      // Remove 'activewish' class from all elements
      document.querySelectorAll('.ctm_wish.activewish').forEach(el => {
        el.classList.remove('activewish');
      });
    }
  });
});









